/**
 * Cookie name for HoneyBook anonymous ID used in analytics tracking
 */
export const HB_ANONYMOUS_ID_COOKIE_NAME = 'hb_anonymous_id';
//# sourceMappingURL=analytics-constants.js.map